jQuery(document).ready(function(){
    jQuery('.orbit').each(function(){
        var orbit = this;
        orbit.stopped = false;
        setInterval(function(){
            if(!orbit.stopped){
                jQuery(orbit).foundation('changeSlide');
            }
        }, 5000);

        jQuery(orbit).mouseenter(function(){
            orbit.stopped = true;
        }).mouseleave(function(){
            orbit.stopped = false;
        }).focusin(function(){
            orbit.stopped = true;
        }).focusout(function(){
            orbit.stopped = false;
        }).keyup(function(e){
            if(e.keyCode == '37' || e.keyCode == '39') {
                orbit.stopped = true;
             }
        });

        jQuery(orbit).find('.vk-orbit-previous').click(function(){
            jQuery(orbit).foundation('changeSlide', false);
            orbit.stopped = true;
        });
        jQuery(orbit).find('.vk-orbit-next').click(function(){
            jQuery(orbit).foundation('changeSlide', true);
            orbit.stopped = true;
        });

        /* 
            Fixes a buggy functionality in orbit slider that resized the container 
            sometimes based on the smaller slide when the window was resized 
        */
        var orbit_container = jQuery(orbit).find('.orbit-container')[0];
        var observer = new MutationObserver(function(mutationsList, observer){
            for(var mutation of mutationsList){
                var slide_max_height = 0;
                jQuery(orbit).find('.orbit-slide').each(function(){
                    var slide_height = parseInt(jQuery(this).css('height'));
                    if(slide_height > slide_max_height){
                        slide_max_height = slide_height;
                    }
                });
                jQuery(orbit_container).css('min-height', slide_max_height+'px');
            }
        });
        observer.observe(orbit_container, {
            attributeFilter: ['style'],
        });
    });
});